
const prefix = 'operator';
export const EVENTS_OPERATOR = {
  DISCONNECTED: `disconnect`,
  CONNECTED: `${prefix}.connected`,
  STATUS_CHANGED: `${prefix}.status_changed`,
  CONVERSATION_JOINED: `${prefix}.conversation_joined`,
  CONVERSATION_LEAVED: `${prefix}.conversation_leaved`,
  TYPING: `${prefix}.typing`,
}; 
